import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

// components

import { Modal } from 'app-components';
import GIButton from '../../../components/common/button/GIButton';

// props

interface ViewMemberAccountModalProps {
    encHHId: string;
    hhId: string;
    hhFirstName: string;
    hhLastName: string;
    switchToModuleName: string;
    onHandleViewMemberAccount?: () => void;
    onClose: () => void;
    title?: string;
    secondaryBtnLabel?: string;
    primaryBtnLabel?: string;
    viewType?: string;
    switchToNonDefaultURL?: string;
    action?: string;
}

// styles

const StyledControls = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    .f-center {
        display: flex;
        align-items: center;
        column-gap: 10px;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;

        .f-center {
            column-gap: 5px;
        }
    }
`;

const StyledBody = styled.div`
    .gi-modal__body {
        margin-bottom: 0;
    }
`;

const StyledText = styled.p`
    marign-top: 1rem;
`;

function ViewMemberAccountModal({
    encHHId,
    hhId,
    hhFirstName,
    hhLastName,
    switchToModuleName,
    onClose,
    viewType = 'Member',
    secondaryBtnLabel = 'common.cancel',
    primaryBtnLabel = 'common.member_view',
    title = 'modals.header.view_member_account',
    switchToNonDefaultURL = '',
    action = 'take actions',
}: ViewMemberAccountModalProps) {
    const [checkShowMessage, setCheckedShowMessage] = useState(false);

    const onClickMemberViewHandler = async () => {
        // start impersonation mode
        sessionStorage.isInImpersonationMode = true;
        sessionStorage.impersonateHHID = hhId;
        const checkConsumerView = checkShowMessage ? 'on' : '';
        sessionStorage.checkDilog = checkConsumerView;
        // redirect
        const switchToResourceName = encodeURIComponent(`${hhFirstName} ${hhLastName}`);
        const url = `/hix/crm/consumer/dashboard?checkConsumerView=${checkConsumerView}&switchToModuleName=${switchToModuleName}&switchToModuleId=${encHHId}&switchToResourceName=${switchToResourceName}&switchToNonDefaultURL=${switchToNonDefaultURL}`;
        window.location.href = url;
    };

    const onHandleCheckChange = () => {
        setCheckedShowMessage(!checkShowMessage);
    };

    return (
        <Modal id="view_member_account_modal" data-testid="modal">
            <Modal.Header id="view_member_account_modal_title" titleId={title} onHide={onClose} />
            <StyledBody>
                <Modal.Body>
                    <div>
                        {/* Clicking "Member View" will take you to the Member's portal for {hhFirstName} {hhLastName}. */}
                        <FormattedMessage
                            id="modals.view_member_account.text"
                            values={{
                                consumerName: `${hhFirstName} ${hhLastName}`,
                                viewType,
                            }}
                        />
                    </div>
                    <div>
                        <FormattedMessage
                            id="modals.view_member_account.text_two"
                            values={{ action, viewType: viewType.toLowerCase() }}
                        />
                    </div>
                    <StyledText>
                        {/* Proceed to Member view? */}
                        <FormattedMessage id="modals.view_member_account.text_three" values={{ viewType }} />
                    </StyledText>
                </Modal.Body>
            </StyledBody>
            <Modal.Controls>
                <StyledControls>
                    <div className="f-center">
                        <input
                            type="checkbox"
                            id="checkConsumerView"
                            checked={checkShowMessage}
                            name="checkConsumerView"
                            onChange={onHandleCheckChange}
                        />
                        <FormattedMessage id="modals.view_member_account.checkbox" />
                    </div>
                    <div>
                        <GIButton
                            id="cancel"
                            labelId={secondaryBtnLabel}
                            variant="secondary"
                            onClickHandler={onClose}
                        ></GIButton>
                        <GIButton
                            id="member_view"
                            labelId={primaryBtnLabel}
                            onClickHandler={onClickMemberViewHandler}
                        ></GIButton>
                    </div>
                </StyledControls>
            </Modal.Controls>
        </Modal>
    );
}

export default ViewMemberAccountModal;
